<template>
  <v-container fluid>
    <v-flex xs12 sm12 md12>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="AVISO!=null">
          <v-toolbar dark color="#969462">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{AVISO.titulo}}</v-toolbar-title>
          </v-toolbar>

          <v-flex xs11 sm11 md11 style="display: flex; justify-content: center; padding: 50px;">
            <v-flex xs12 sm12 md12 v-html="AVISO.descricao"></v-flex>
          </v-flex>
        </v-card>
      </v-dialog>

      <v-layout row wrap>
        <!-- <v-flex class="pb-4" v-if="getSession.user.falta != false && getSession.user.falta != null" xs12 sm12 md12>
                <h1 style="color: #969462 !important;">Documentos em falta</h1>
                <v-flex xs12 sm12 md12 style="display: flex !important; justify-content: flex-start !important;">
                    <div class="item-object" @click="open()">
                        <span>
                            <v-icon color="primary">description</v-icon>
                        </span>
                        <span>
                            <p>Em_Falta.pdf</p>
                        </span>
                    </div>
                </v-flex>
        </v-flex>-->

        <v-flex v-if="getSession.user.super == 0" class="pb-4" xs12 sm12 md12>
          <h1 style="color: #969462 !important;">Documentos em falta</h1>
          <v-layout
            v-if="getSession.user.falta"
            row
            wrap
            style="display: flex; align-items: baseline;"
          >
            <div
              class="square noselect"
              v-for="(item, i) in Object.keys(getSession.user.falta)"
              :key="i"
            >
              <div class="item-object" @click="open(getSession.user.falta[item])">
                <span>
                  <v-icon color="primary">description</v-icon>
                </span>
                <span>
                  <p>{{getSession.user.falta[item]}}</p>
                </span>
              </div>
            </div>
          </v-layout>
          <p v-else class="label-modal">Sem documentos em falta</p>
        </v-flex>

        <v-flex class="pb-4" v-if="getNotificacoes.length > 0" xs12 sm12 md12>
          <h1 style="color: #969462 !important;">
            Notificações
            <span v-if="loadingN">
              <v-progress-circular size="20" width="2" indeterminate color="grey"></v-progress-circular>
            </span>
            <span v-else @click="getNotificacoesTodos()" class="dados-info">{{dadosN}}</span>
          </h1>
          <v-alert
            v-for="(item, i) in getNotificacoes"
            :key="i"
            :value="true"
            :color="(item.visto == 1 || getSession.user.super == 1) ? 'grey' : 'success'"
            icon="notification_important"
            style="cursor: pointer !important;"
            outline
            @click="setNotificationChecked(item)"
          >
            <span>
              <b>{{item.titulo}}</b>
              {{item.descricao}}
            </span>
          </v-alert>
        </v-flex>

        <v-flex class="pb-4" v-if="getAvisos.length > 0" xs12 sm12 md12>
          <h1 style="color: #969462 !important;">
            Informações Relevantes
            <span v-if="loadingA">
              <v-progress-circular size="20" width="2" indeterminate color="grey"></v-progress-circular>
            </span>
            <span v-else @click="getAvisosTodos()" class="dados-info">{{dadosA}}</span>
          </h1>
          <v-alert
            v-for="(item, i) in getAvisos"
            :key="i"
            :value="true"
            color="grey"
            icon="warning"
            style="cursor: pointer !important;"
            outline
            @click="setAvisoChecked(item)"
          >
            <span>
              <b>{{item.titulo}}</b>
            </span>
          </v-alert>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    todosN: false,
    todosA: false,
    loadingN: false,
    loadingA: false,
    dados: "Resultados dos últimos 30 dias",
    AVISO: null
  }),
  computed: {
    ...mapGetters({
      getSession: "session/getState",
      getNotificacoes: "notificacoes/getAll",
      getAvisos: "avisos/getAll",
      getStateA: "avisos/getState",
      getStateN: "notificacoes/getState"
    }),
    dadosN() {
      return this.todosN ? "Dados desde sempre" : this.dados;
    },
    dadosA() {
      return this.todosA ? "Dados desde sempre" : this.dados;
    }
  },
  created() {
    this.todosA = this.getStateA;
    this.todosN = this.getStateN;
  },
  methods: {
    getAvisosTodos() {
      if (this.todosA) return;
      this.loadingA = true;
      if (this.getSession.user.super == 1) {
        this.$store.dispatch("avisos/get", true).then(res => {
          this.todosA = true;
          this.loadingA = false;
        });
      } else {
        this.$store.dispatch("avisos/getByEscritorio", true).then(res => {
          this.todosA = true;
          this.loadingA = false;
        });
      }
    },

    getNotificacoesTodos() {
      if (this.todosN) return;
      this.loadingN = true;
      if (this.getSession.user.super == 1) {
        this.$store.dispatch("notificacoes/get", true).then(res => {
          this.todosN = true;
          this.loadingN = false;
        });
      } else {
        this.$store.dispatch("notificacoes/getByUser", true).then(res => {
          this.todosN = true;
          this.loadingN = false;
        });
      }
    },

    setNotificationChecked(item) {
      if (item.visto == 1 || this.getSession.user.super == 1) return;

      this.$store
        .dispatch("notificacoes/setChecked", {
          id: item.id_notificacao_utilizador,
          visto: 1,
          data_visto: this.$moment().format("YYYY-MM-DD HH:mm")
        })
        .then(res => {
          if (res) item.visto = 1;
        });
    },
    setAvisoChecked(item) {
      this.AVISO = Object.assign({}, item);
      this.dialog = true;

      /*if (item.visto == 1 || this.getSession.user.super == 1) return;

      setTimeout(() => {
        this.$store
          .dispatch("avisos/setChecked", {
            id: item.id_aviso_utilizador,
            visto: 1,
            data_visto: this.$moment().format("YYYY-MM-DD HH:mm")
          })
          .then(res => {
            if (res) item.visto = 1;
          });
      }, 50);*/
    }, 
    open(path) {
      window.open(
        this.$fileURL + this.getSession.user.codigo + "/50.Em falta/" + path,
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
b {
  text-transform: uppercase !important;
  margin-right: 10px !important;
}

.item-object {
  display: grid;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}

.item-object span i {
  font-size: 40px !important;
}

.item-object span p {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 80px;
  white-space: nowrap;
}

.titulo {
  font-weight: 700 !important;
  text-transform: uppercase !important;
  font-size: 15px !important;
  margin-right: 10px !important;
}

.data {
  font-size: 11px !important;
  color: #9e9e9e;
}

.data-warning {
  font-size: 11px !important;
  color: #4caf50 !important;
}

.dados-info {
  font-size: 11px;
  color: grey;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue